<template>
  <div class="vip">
    <div class="xin-vip">
      <TabList curId="0" style="margin-bottom: 18px"></TabList>
      <PayOrderVip @allQuan="allQuanFn('idPayJuris')"></PayOrderVip>
      <div class="PayJurisdiction-box">
        <div id="idPayJuris" class="PayJurisdiction-title">{{$t('vip.allBenefits')}}</div>
        <PayJurisdiction></PayJurisdiction>
      </div>
    </div>
  </div>
</template>

<script>
import TabList from "../TabList/index.vue";
import PayOrderVip from "@/components/PayOrderVip/index";
import PayJurisdiction from "@/components/PayJurisdiction/index";
// Hotjar跟踪函数
const loadHotjar = () => {
  (function(h,o,t,j,a,r){
    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
    h._hjSettings={hjid:3000351,hjsv:6};
    a=o.getElementsByTagName('head')[0];
    r=o.createElement('script');r.async=1;
    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
    a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
};
export default {
  components: {
    TabList,
    PayOrderVip,
    PayJurisdiction,
  },
  data() {
    return {
      PayJurisisShow: false,
    };
  },
  created() {
    
    this.$store.commit("setAttr", {
      name: "route_ids",
      val: ['A1'],
    })
    this.$store.commit("setAttr", {
      name: "statusNum",
      val: '',
    })
    this.$store.commit("setAttr", {
      name: "voucher",
      val: '',
    })
    this.$store.commit("setAttr", {
      name: "is_pc",
      val: 0,
    })
  },
  destroyed() {
    sessionStorage.removeItem('expand');
  },
  mounted() {
    // 每次挂载时执行Hotjar跟踪代码
    loadHotjar();
  },
  methods: {
    allQuanFn(sectionId){
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
